import PropTypes from 'prop-types';

import ExpandAnimation from 'Animation/ExpandAnimation';

const ExpandableContent = ({ ariaLabelledBy, children, isShown }) => {
  return (
    <ExpandAnimation
      aria-hidden={!isShown}
      aria-labelledby={ariaLabelledBy}
      className="py-0 px-0.5 mb-2 overflow-hidden"
      isShown={isShown}
    >
      {children}
    </ExpandAnimation>
  );
};

ExpandableContent.propTypes = {
  ariaLabelledBy: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isShown: PropTypes.bool.isRequired,
};

export default ExpandableContent;
